import { useMemo, useState } from 'react';
import newAddresses from '../../data/vn-address-new.json';
import oldAddresses from '../../data/vn-address-old.json';

const AddressFields = ({ value, onChange }) => {
  const [mode, setMode] = useState(value.mode || 'new');
  const [provinceCode, setProvinceCode] = useState('');
  const [districtCode, setDistrictCode] = useState('');
  const [wardCode, setWardCode] = useState('');
  const [street, setStreet] = useState(value.street || '');

  const provinces = mode === 'new' ? newAddresses : oldAddresses;
  const province = useMemo(
    () => provinces.find((item) => String(item.code) === String(provinceCode)) || null,
    [provinces, provinceCode]
  );
  const districts = province?.districts || [];
  const district = districts.find((item) => String(item.code) === String(districtCode)) || null;
  const wards = mode === 'new' ? (province?.wards || []) : (district?.wards || []);

  const emit = (next) => {
    const nextMode = next.mode ?? mode;
    const nextProvince = next.province ?? province;
    const nextDistrict = next.district === undefined ? district : next.district;
    const nextWard = next.ward === undefined ? wards.find((item) => String(item.code) === String(wardCode)) : next.ward;
    const nextStreet = next.street ?? street;
    const parts = [nextStreet.trim()];
    if (nextWard?.name) parts.push(nextWard.name);
    if (nextMode === 'old' && nextDistrict?.name) parts.push(nextDistrict.name);
    if (nextProvince?.name) parts.push(nextProvince.name);
    const address = parts.filter(Boolean).join(', ');
    const suffix = nextMode === 'new' ? ' (địa chỉ mới)' : ' (địa chỉ cũ)';
    onChange({
      mode: nextMode,
      street: nextStreet,
      address: address ? `${address}${suffix}` : '',
      provinceName: nextProvince?.name || '',
      complete: Boolean(nextStreet.trim() && nextProvince && nextWard && (nextMode === 'new' || nextDistrict)),
    });
  };

  const switchMode = (nextMode) => {
    setMode(nextMode);
    setProvinceCode('');
    setDistrictCode('');
    setWardCode('');
    emit({ mode: nextMode, province: null, district: null, ward: null });
  };

  return (
    <div className="address-fields">
      <div className="address-mode">
        <button type="button" className={mode === 'new' ? 'active' : ''} onClick={() => switchMode('new')}>
          Địa chỉ mới
        </button>
        <button type="button" className={mode === 'old' ? 'active' : ''} onClick={() => switchMode('old')}>
          Địa chỉ cũ
        </button>
      </div>
      <label>
        Tỉnh/Thành phố
        <select
          value={provinceCode}
          onChange={(e) => {
            const code = e.target.value;
            const found = provinces.find((item) => String(item.code) === code) || null;
            setProvinceCode(code);
            setDistrictCode('');
            setWardCode('');
            emit({ province: found, district: null, ward: null });
          }}
        >
          <option value="">Chọn tỉnh/thành phố</option>
          {provinces.map((item) => (
            <option key={item.code} value={item.code}>{item.name}</option>
          ))}
        </select>
      </label>
      {mode === 'old' ? (
        <label>
          Quận/Huyện
          <select
            value={districtCode}
            disabled={!province}
            onChange={(e) => {
              const code = e.target.value;
              const found = districts.find((item) => String(item.code) === code) || null;
              setDistrictCode(code);
              setWardCode('');
              emit({ district: found, ward: null });
            }}
          >
            <option value="">Chọn quận/huyện</option>
            {districts.map((item) => (
              <option key={item.code} value={item.code}>{item.name}</option>
            ))}
          </select>
        </label>
      ) : null}
      <label>
        Phường/Xã
        <select
          value={wardCode}
          disabled={mode === 'new' ? !province : !district}
          onChange={(e) => {
            const code = e.target.value;
            const found = wards.find((item) => String(item.code) === code) || null;
            setWardCode(code);
            emit({ ward: found });
          }}
        >
          <option value="">Chọn phường/xã</option>
          {wards.map((item) => (
            <option key={item.code} value={item.code}>{item.name}</option>
          ))}
        </select>
      </label>
      <label>
        Số nhà, tên đường
        <input
          value={street}
          onChange={(e) => {
            setStreet(e.target.value);
            emit({ street: e.target.value });
          }}
          placeholder="Ví dụ: 12 ngõ 5"
        />
      </label>
    </div>
  );
};

export default AddressFields;
